import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ButtonComponent, ButtonClass } from "@claas/claas-ui-components";
import {
  DialogModalComponent,
  ModalSize,
} from "@claas/claas-ui-components/layout/dialog-modal";
import { TranslateModule } from "@ngx-translate/core";
import { userContextStore } from "../../../../shared/data/user-context.store";

@Component({
  selector: "claas-change-language-dialog",
  templateUrl: "./change-language-dialog.html",
  styleUrls: ["./change-language-dialog.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DialogModalComponent, ButtonComponent, TranslateModule],
})
export class ChangeLanguageDialogComponent {
  protected readonly store = inject(userContextStore);
  private readonly dialogRef = inject(
    MatDialogRef<ChangeLanguageDialogComponent>,
  );

  protected readonly modalSize = ModalSize.SMALL;
  protected readonly buttonClass = ButtonClass;
  protected readonly selectedLanguage = signal(this.store.language());

  protected select(language: string): void {
    this.selectedLanguage.set(language);
  }

  protected confirm(): void {
    this.store.setLanguage(this.selectedLanguage());
    this.dialogRef.close();
  }

  protected cancel(): void {
    this.dialogRef.close();
  }
}
